/**
 * H5：发版后旧入口仍引用已失效的 hashed chunk 时，
 * 动态 import 会拿到 SPA 回落的 HTML → MIME 报错 →「连接服务器超时」。
 * 捕获后硬刷新一次，拉到最新 index.html。
 */

const RELOAD_AT_KEY = 'csc_chunk_reload_at'
const RELOAD_COOLDOWN_MS = 15_000

function shouldReloadNow(): boolean {
  try {
    const last = Number(sessionStorage.getItem(RELOAD_AT_KEY) || 0)
    const now = Date.now()
    if (now - last < RELOAD_COOLDOWN_MS) return false
    sessionStorage.setItem(RELOAD_AT_KEY, String(now))
    return true
  } catch {
    return true
  }
}

export function reloadForStaleChunks(reason = 'stale-chunk'): void {
  if (typeof location === 'undefined') return
  if (!shouldReloadNow()) return
  console.warn('[chunk-reload]', reason)
  location.reload()
}

function isChunkLoadError(err: unknown): boolean {
  const msg = String(
    (err as { message?: string } | null)?.message ?? err ?? '',
  )
  return (
    /Failed to fetch dynamically imported module/i.test(msg) ||
    /Importing a module script failed/i.test(msg) ||
    /error loading dynamically imported module/i.test(msg) ||
    /Expected a JavaScript-or-Wasm module script/i.test(msg)
  )
}

/** 在 App onLaunch（H5）调用一次 */
export function installChunkReloadGuard(): void {
  if (typeof window === 'undefined') return

  window.addEventListener('vite:preloadError', ((e: Event) => {
    e.preventDefault()
    reloadForStaleChunks('vite:preloadError')
  }) as EventListener)

  window.addEventListener('unhandledrejection', (e) => {
    if (isChunkLoadError(e.reason)) {
      reloadForStaleChunks(String((e.reason as Error)?.message || e.reason))
    }
  })
}
